import Joi from 'joi';
import PropTypes from 'prop-types';
import Form from '../common/form';

class HelideckCoverForm extends Form {
	state = {
		data: initialData,
		errors: {},
		loading: false,
		progress: 0,
	};

	static propTypes = {
		onProceed: PropTypes.func,
	};

	schema = {
		drawingNo: Joi.string().allow('').required().label('Drawing Number'),
		visualTesting: Joi.string()
			.min(5)
			.required()
			.label('Visual Testing Procedure'),
		helideckCoefficient: Joi.string()
			.min(5)
			.required()
			.label('Helideck Co-efficient of Friction Test Preocedure'),
		helideckFrictionRequirement: Joi.string()
			.min(3)
			.required()
			.label('Helideck Friction Requirement'),
		testTyreSpec: Joi.string()
			.min(3)
			.required()
			.label('Test Tyre Specification'),
		roadMarking: Joi.string()
			.min(3)
			.required()
			.label('Road Marking Specification'),
		materialCalibration: Joi.string()
			.min(3)
			.required()
			.label('Material On Calibration Friction Measurement'),
		calibrationFriction: Joi.string()
			.min(3)
			.required()
			.label('Calibration Friction Measurement'),
		iso: Joi.string()
			.min(3)
			.required()
			.label('International Organization For Standardization'),
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onProceed(this.state.data);

		this.setState({ data: initialData });
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'drawingNo',
							label: 'Drawing Number',
							placeholder: 'Optional',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'visualTesting',
							label: 'Visual Testing Procedure',
							placeholder: 'e.g. RS-OPS-MIM-P-1035',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'helideckCoefficient',
							label: 'Helideck Co-efficient of Friction Test Preocedure',
							placeholder: 'e.g. RS-OPS-SDM-P-1015',
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'helideckFrictionRequirement',
							label: 'Helideck Friction Requirement',
							placeholder: 'e.g. UK CAA CAP 437',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'testTyreSpec',
							label: 'Test Tyre Specification',
							placeholder: 'e.g. ASTME 1844',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'roadMarking',
							label: 'Road Marking Specification',
							placeholder: 'e.g. EN 1436',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'materialCalibration',
							label: 'MOC Friction Measurement',
							placeholder: 'e.g. ASM, Part 2',
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'iso',
							label: 'International Organization For Standardization',
							placeholder: 'e.g. ISO 9001 2008 SYSTEM',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'calibrationFriction',
							label: 'Calibration Friction Measurement',
							placeholder: 'e.g. ICAO Annex 144',
						})}
					</div>
				</div>

				<div className="d-flex justify-content-end">
					{this.renderButton('Proceed')}
				</div>
			</form>
		);
	}
}

export default HelideckCoverForm;

const initialData = {
	drawingNo: '',
	visualTesting: '',
	helideckCoefficient: '',
	helideckFrictionRequirement: '',
	testTyreSpec: '',
	roadMarking: '',
	materialCalibration: '',
	calibrationFriction: '',
	iso: '',
};
